<template>
    <div :class="{'display-inline': inline}">
        <template v-if="discount">
            <strike class="text-danger"><small>&pound;</small>{{ calculatedPrice|number_format }}</strike> &pound; {{ discountedPrice|number_format }}<span class="vat" v-if="showTax"><slot></slot> <span v-if="service.show">Inc.</span><span v-else>Exc.</span> VAT</span>
        </template>
        <template v-else>
            <small>&pound;</small>{{ calculatedPrice|number_format }}<span class="vat" v-if="showTax"><slot></slot> <span v-if="service.show">Inc.</span><span v-else>Exc.</span> VAT</span>
        </template>
    </div>
</template>

<script>
    import Tax from '../../Services/Tax.js';

    export default {
        props: {
            price: {
                default: 0
            },
            tax: {
                default: 0
            },
            discountTax: {
                default: 0
            },
            discount: {
                default: 0
            },
            showTax: {
                default: true
            },
            inline: {
                default: false
            }
        },
        data() {
            return {
                service: Tax
            }
        },
        computed: {
            calculatedPrice() {
                if (this.service.show) {
                    return parseFloat(this.price) + this.tax;
                }
                return parseFloat(this.price);
            },
            discountedPrice() {
                if (this.service.show) {
                    return this.calculatedPrice - (this.discount + this.discountTax);
                }
                return this.calculatedPrice - this.discount;
            }
        }
    }
</script>

<style scoped>
    .display-inline {
        display:inline-block;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Product/ProductPrice.vue